"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadExemple = exports.toPrecision = exports.set_nodes_level = exports.setSelectedTags = exports.link_text = exports.getTotalLinks = exports.getLinkValue = exports.getColor = exports.delete_node = exports.delete_link = exports.default_sankey_data = exports.default_node = exports.default_link = exports.compute_total_offsets = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _SankeyConvert = require("./SankeyConvert");

// Getter pour récupérer la valeur du link
// utile pour pouvoir ensuite gérer les dataTag
var getLinkValue = function getLinkValue(data, idLink) {
  var links = data.links;
  return links[idLink].value[0];
};

exports.getLinkValue = getLinkValue;

var getTotalLinks = function getTotalLinks(data, Links) {
  var links = data.links;
  var total = 0;
  Links.forEach(function (element) {
    // On vérifie que le lien est affiché, cad que le noeud source et le noeud target sont
    if (data.nodes[data.links[element].idSource].node_visible && data.nodes[data.links[element].idTarget].node_visible) {
      var tmp = links[element].value[0];
      total += tmp;
    }
  });
  return total;
};

exports.getTotalLinks = getTotalLinks;

var compute_total_offsets = function compute_total_offsets(node, nodes, links, selected_tags, test_link_value) {
  var ref_link = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var offset_height_left = 0;
  var offset_height_right = 0;
  var offset_width_top = 0;
  var offset_width_bottom = 0;
  var left_flux = [];
  var right_flux = [];
  var top_flux = [];
  var bottom_flux = []; //const link_id = link ? links.indexOf(link) : -1

  node.outputLinksId.forEach(function (idLink) {
    var link = links[idLink];

    if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
      var target_node;

      try {
        target_node = nodes[link.idTarget];
      } catch (_unused) {
        return;
      }

      if (link.orientation === 'hh') {
        if (target_node.x > node.x && !link.recycling || target_node.x <= node.x && link.recycling) {
          right_flux.push(idLink);
        } else {
          left_flux.push(idLink);
        }
      } else if (link.orientation === 'vv') {
        if (target_node.y > node.y) {
          bottom_flux.push(idLink);
        } else {
          top_flux.push(idLink);
        }
      } else if (link.orientation === 'hv') {
        if (target_node.x > node.x) {
          right_flux.push(idLink);
        } else {
          left_flux.push(idLink);
        }
      } else if (link.orientation === 'vh') {
        if (target_node.y > node.y) {
          bottom_flux.push(idLink);
        } else {
          top_flux.push(idLink);
        }
      }
    }
  });
  node.inputLinksId.forEach(function (idLink) {
    var link = links[idLink];

    if (nodes[link.idSource].node_visible && nodes[link.idTarget].node_visible) {
      var source_node;

      try {
        source_node = nodes[link.idSource];
      } catch (_unused2) {
        return;
      }

      if (link.orientation === 'vv') {
        if (source_node.y < node.y) {
          // flux goes down
          top_flux.push(idLink);
        } else {
          // flux goes up
          bottom_flux.push(idLink);
        }
      } else if (link.orientation === 'hh') {
        if (source_node.x >= node.x && link.recycling || source_node.x < node.x && !link.recycling) {
          // flux goes right
          left_flux.push(idLink);
        } else {
          // flux goes left
          right_flux.push(idLink);
        }
      } else if (link.orientation === 'hv') {
        if (source_node.y < node.y) {
          // flux goes right
          top_flux.push(idLink);
        } else {
          // flux goes left
          bottom_flux.push(idLink);
        }
      } else if (link.orientation === 'vh') {
        if (source_node.x < node.x) {
          // flux goes right
          left_flux.push(idLink);
        } else {
          // flux goes left
          right_flux.push(idLink);
        }
      }
    }
  });
  var top_order = -1;

  if (ref_link) {
    top_order = top_flux.indexOf(ref_link.idLink);
  }

  top_flux.forEach(function (id, i) {
    if (top_order !== -1 && (i > top_order || i === 0)) {
      return;
    }

    var the_id = id;

    if (top_order !== -1) {
      the_id = top_flux[i - 1];
    }

    var v = test_link_value(nodes, links[the_id], selected_tags);
    console.log(v);

    if (v === undefined) {
      return;
    }

    offset_width_top += +v;
  });
  var bottom_order = -1;

  if (ref_link) {
    bottom_order = bottom_flux.indexOf(ref_link.idLink);
  }

  bottom_flux.forEach(function (id, i) {
    if (bottom_order !== -1 && (i > bottom_order || i === 0)) {
      return;
    }

    var the_id = id;

    if (bottom_order !== -1) {
      the_id = bottom_flux[i - 1];
    }

    var v = test_link_value(nodes, links[the_id], selected_tags);

    if (v === undefined) {
      return;
    }

    offset_width_bottom += +v;
  });
  var left_order = -1;

  if (ref_link) {
    left_order = left_flux.indexOf(ref_link.idLink);
  }

  left_flux.forEach(function (id, i) {
    if (left_order !== -1 && (i > left_order || i === 0)) {
      return;
    }

    var the_id = id;

    if (left_order !== -1) {
      the_id = left_flux[i - 1];
    }

    var v = test_link_value(nodes, links[the_id], selected_tags);

    if (v === undefined) {
      return;
    }

    offset_height_left += +v;
  });
  var right_order = -1;

  if (ref_link) {
    right_order = right_flux.indexOf(ref_link.idLink);
  }

  right_flux.forEach(function (id, i) {
    if (right_order !== -1 && (i > right_order || i === 0)) {
      return;
    }

    var the_id = id;

    if (right_order !== -1) {
      the_id = right_flux[i - 1];
    }

    var v = test_link_value(nodes, links[the_id], selected_tags);

    if (v === undefined) {
      return;
    }

    offset_height_right += +v;
  });
  return [offset_height_left, offset_height_right, offset_width_top, offset_width_bottom];
};

exports.compute_total_offsets = compute_total_offsets;

var toPrecision = function toPrecision(v) {
  if (v < 1) {
    return String(v.toFixed(1).replace(/\.0+$/, ''));
  }

  var new_v = v.toPrecision(3).replace(/\.0+$/, '');

  if (new_v.includes('e+3')) {
    new_v = String(parseFloat(new_v));
  }

  return new_v;
};

exports.toPrecision = toPrecision;

var link_text = function link_text(d, link_value, display_style, reg_index) {
  var str_display = String(d.display_value[reg_index]);

  if (str_display !== 'default') {
    return str_display;
  }

  var the_link_value = toPrecision(link_value);
  return the_link_value;
};

exports.link_text = link_text;

var default_sankey_data = function default_sankey_data() {
  return {
    version: '0.5',
    nodes: {},
    links: {},
    user_scale: 100,
    //height: 1500,
    width: 2150,
    node_width: 10,
    h_space: 200,
    v_space: 100,
    legend_position: [0, 100],
    left_shift: 0.4,
    right_shift: 0.5,
    max_shift: 0.2,
    display_style: {
      font_size: 11,
      sector_uppercase: true,
      sector_bold: true,
      sector_italic: false,
      product_uppercase: false,
      product_bold: false,
      product_italic: true,
      unit: false,
      filter: 0,
      filter_label: 0,
      global_curvature: 0.5,
      null_flux: false
    },
    tags_catalog: {},
    tags_group_idx: 1,
    tag_idx: 1,
    node_idx: 1,
    link_idx: 1
  };
};

exports.default_sankey_data = default_sankey_data;

var default_node = function default_node() {
  console.log('-> Affectation du default_node');
  var defaultNode = {
    name: '',
    idNode: 'default',
    type: 'sector',
    display: true,
    node_visible: true,
    shape_visible: true,
    label_visible: true,
    color: '#a9a9a9',
    node_parameter: 'general',
    x: 100,
    y: 100,
    inputLinksId: [],
    outputLinksId: [],
    show_value: false,
    tags: {},
    tag_favorite: {},
    colorFavoriteTags: {},
    dimensions: {
      'Primaire': {
        parent_name: undefined
      }
    }
  };
  return defaultNode;
};

exports.default_node = default_node;

var default_link = function default_link() {
  return {
    idSource: 'node0',
    idTarget: 'node1',
    idLink: 'link0',
    value: [10],
    display_value: ['default'],
    color: '#a9a9a9',
    curved: false,
    arrow: true,
    text_color: 'black',
    label_position: 'middle',
    orthogonal_label_position: 'middle',
    curvature: 0.5,
    label_visible: true,
    label_on_path: true,
    orientation: 'hh',
    left_horiz_shift: 0,
    right_horiz_shift: 0,
    vert_shift: 0,
    shift_gap: 0.1,
    tags: {}
  };
};

exports.default_link = default_link;

var delete_link = function delete_link(data, link) {
  var source_node = data.nodes[link.idSource];
  var idx = source_node.outputLinksId.findIndex(function (idLink) {
    return idLink === link.idLink;
  });
  source_node.outputLinksId.splice(idx, 1);
  var target_node = data.nodes[link.idTarget];
  idx = target_node.inputLinksId.findIndex(function (idLink) {
    return idLink === link.idLink;
  });
  target_node.inputLinksId.splice(idx, 1);
  delete data.links[link.idLink];
};

exports.delete_link = delete_link;

var delete_node = function delete_node(data, node) {
  node.inputLinksId.forEach(function (idLink) {
    return delete_link(data, data.links[idLink]);
  });
  node.outputLinksId.forEach(function (idLink) {
    return delete_link(data, data.links[idLink]);
  });
  delete data.nodes[node.idNode];
};

exports.delete_node = delete_node;

var setSelectedTags = function setSelectedTags(sankey_data) {
  var tags_catalog = sankey_data.tags_catalog;
  var display_nodes = Object.values(sankey_data.nodes).filter(function (n) {
    return n.display;
  });
  display_nodes.forEach(function (node) {
    node.node_visible = true;
    var break_loop = false;
    var no_tag = true;
    Object.keys(tags_catalog).forEach(function (tags_group_key) {
      if (break_loop) {
        return;
      }

      var tags_group = tags_catalog[tags_group_key];

      if (!node.tags[tags_group_key] || node.tags[tags_group_key].length === 0) {
        // tags do not apply to node
        return;
      }

      no_tag = false;
      var visible = Object.keys(tags_group.tags).filter(function (tag_key) {
        return tags_group.tags[tag_key].selected && node.tags[tags_group_key].includes(tag_key);
      }).length > 0;

      if (!visible) {
        node.node_visible = false;
        break_loop = true;
      }
    }); // for the labels

    if (no_tag && !node.shape_visible && !node.label_visible) {
      node.node_visible = true;
    }
  });
};

exports.setSelectedTags = setSelectedTags;

var downloadExamples = function downloadExamples(file_name, the_url_prefix, filetype) {
  var root = window.location.href;

  if (root.includes('sankey-diagrams') && the_url_prefix !== '') {
    root = root.replace('sankey-diagrams/', '');
  }

  var url = root + the_url_prefix + 'sankey/download_examples';
  var fetchData = {
    method: 'POST',
    body: file_name
  };

  var showFile = function showFile(blob) {
    var newBlob = new Blob([blob], {
      type: filetype
    });

    _fileSaver.default.saveAs(newBlob, file_name);
  };

  fetch(url, fetchData).then(function (response) {
    if (response.ok) {
      response.blob().then(showFile);
    }
  });
};

var uploadExemple = function uploadExemple(file_name, the_url_prefix, data, set_data, example_callback) {
  var root = window.location.href;

  if (root.includes('sankey-diagrams') && the_url_prefix !== '') {
    root = root.replace('sankey-diagrams/', '');
  }

  var url = root + the_url_prefix + 'sankey/upload_examples';
  var fetchData = {
    method: 'POST',
    body: file_name
  };
  var file_type = 'text/plain';
  set_data((0, _objectSpread2.default)({}, default_sankey_data()));
  file_type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  fetch(url, fetchData).then(function (response) {
    response.text().then(function (text) {
      // try {
      var server_data = JSON.parse(text);
      Object.assign(data, server_data);
      (0, _SankeyConvert.convert_data)(data); // data.left_shift = 0.40
      // data.right_shift = 0.50

      data.node_idx = Object.keys(data.nodes).length;
      data.link_idx = Object.keys(data.links).length;
      example_callback(data);
      set_data((0, _objectSpread2.default)({}, data));
      downloadExamples(file_name, the_url_prefix, file_type); // } catch (err) {
      //   alert(err)
      // }
    });
  });
};

exports.uploadExemple = uploadExemple;

var set_nodes_level = function set_nodes_level(display_nodes, level) {
  Object.values(display_nodes).forEach(function (node) {
    if (!node.dimensions['Primaire'] || !node.dimensions['Primaire'].level) {
      node.display = false;
      node.node_visible = false;
      return;
    }

    if (node.dimensions['Primaire'].level === level) {
      node.node_visible = true;
      node.display = true;
      Object.keys(node.dimensions).forEach(function (dim) {
        var idParent = node.dimensions[dim].parent_name;

        if (idParent !== null && idParent !== undefined) {
          display_nodes[idParent].node_visible = false;
          display_nodes[idParent].display = false;
        }
      });
    } else if (node.dimensions['Primaire'].level > level) {
      node.node_visible = false;
      node.display = false;
    }
  });
};

exports.set_nodes_level = set_nodes_level;

var getColor = function getColor(node, data) {
  console.log(node);
};

exports.getColor = getColor;